import { Box } from '@mui/material'
import { ChevronLeft20Regular, ChevronRight20Regular } from '@/components/Icon'
import styles from './index.module.scss'

export default function AssistantMessageVersionNav({
  versionLabel,
  onPrevVersion,
  onNextVersion,
  prevDisabled,
  nextDisabled,
}) {
  return (
    <Box className={styles.versionNav} aria-label="Message versions">
      <button
        type="button"
        className={styles.versionButton}
        aria-label="Previous version"
        disabled={prevDisabled}
        onClick={() => onPrevVersion?.()}
      >
        <ChevronLeft20Regular />
      </button>
      <span className={styles.versionLabel} aria-label="Version index">
        {versionLabel}
      </span>
      <button
        type="button"
        className={styles.versionButton}
        aria-label="Next version"
        disabled={nextDisabled}
        onClick={() => onNextVersion?.()}
      >
        <ChevronRight20Regular />
      </button>
    </Box>
  )
}
